// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* select */

.ant-form-item-control-input-content > .ant-select:hover > .ant-select-selector {
	border-right-width: 0;
}

.float-group.password-input
	.ant-select:not(.ant-select-disabled):hover
	.ant-select-selector {
	border-right-width: 0;
}

.ant-select-dropdown {
	z-index: 99999999999999999999999999;
}

.ant-select-multiple .ant-select-selection-item {
	background-color: var(--dg-card-bg-1);
}

.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
	color: inherit;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector,
textarea {
	border-radius: 6px;
}

.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
	line-height: 42px;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
	min-height: 50px;
	padding: 10px;
}

.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single.ant-select-show-arrow .ant-select-selection-item {
	top: 2px;
	padding-right: 3px;
}

.ant-pagination-options-size-changer.ant-select-open .ant-select-arrow {
	transform: rotate(0deg);
	transition: 300ms all;
}

.ant-pagination-options-size-changer .ant-select-arrow {
	transform: rotate(180deg);
	transition: 300ms all;
}

.label-left .ant-form-item-row .ant-form-item-label {
	text-align: left;
}

.label-right .ant-form-item-row .ant-form-item-label {
	text-align: right;
}

.ant-pagination-options-size-changer .ant-select-selection-item {
	top: 0;
}

.ant-pagination-options-size-changer {
	width: 110px;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input)
	.ant-select-selector
	input {
	height: 100%;
}

.ant-select-selection-placeholder {
	flex: initial;
}

.wallet-deposit .ant-select:not(.ant-select-customize-input) .ant-select-selector {
	border: none;
	border-bottom: 1px solid var(--dg-input-border-color);
	border-radius: 16px 16px 0 0;
}

.wallet-deposit
	.ant-select-focused:not(.ant-select-disabled).ant-select:not(
		.ant-select-customize-input
	)
	.ant-select-selector {
	box-shadow: none;
}

.ant-select-disabled .ant-select-selection-placeholder {
	color: var(--dg-disabled-color-light);
}

.ant-input-suffix {
	position: relative;
	bottom: 4px;
}

/* button */

.ant-btn-ghost {
	border-color: var(--dg-orange-color);
}

.ant-btn-background-ghost.ant-btn-primary:focus {
	background-color: transparent;
	border-color: var(--dg-orange-color);
	color: var(--dg-orange-color);
}

.ant-btn-background-ghost.ant-btn-primary:hover {
	color: var(--dg-primary-color-fixed);
}

.ant-btn-primary:hover,
.ant-btn[disabled],
.ant-btn[disabled]:hover,
.ant-btn[disabled]:focus,
.ant-btn[disabled]:active {
	background-color: var(--dg-orange-color-hover-2);
	border-color: transparent;
}

.ant-btn-primary:hover {
	background-color: var(--dg-orange-color-hover);
	border-color: transparent;
}

.ant-btn-primary:focus {
	background-color: var(--dg-orange-color);
	color: var(--dg-opposite-primary-color);
	border-color: transparent;
}

.ant-btn.ant-btn-default:focus {
	background-color: var(--dg-popOver-bg);
	color: var(--dg-primary-color);
	border-color: var(--dg-primary-color);
}

.ant-btn.ant-btn-default:hover {
	background-color: var(--dg-button-default-bg);
	color: var(--dg-button-default-text);
}

.btn-danger,
.btn-danger:checked {
	background-color: var(--dg-red-color-2);
	color: var(--dg-white-color);
	border-color: var(--dg-red-color-2);
}

.btn-danger:hover {
	background-color: var(--dg-red-color-hover);
	color: var(--dg-white-color);
}

.btn-danger:focus {
	background-color: var(--dg-red-color-hover);
	color: var(--dg-white-color);
}

/* table */

.ant-table-tbody > tr > td {
	border-color: transparent;
}

.ant-table-tbody > tr:not(:last-child) > td {
	border-color: var(--dg-table-border-color);
	/* padding: 18px 8px; */
}

.ant-table-tbody > tr > td {
	background-color: var(--dg-table-bg);
}

.ant-table-thead,
.ant-table-tbody > tr > td {
	height: 60px;
}

/* .ant-table-tbody>tr.ant-table-row:nth-child(even)>td {
    background-color: var(--dg-table-row-even-bg);
}

.ant-table-tbody>tr.ant-table-row:nth-child(odd)>td {
    background-color: var(--dg-table-bg);
} */

.ant-table-tbody > tr.ant-table-row:hover > td {
	background-color: var(--table-row-hover);
}

.ant-table-tbody > tr.ant-table-placeholder:hover > td {
	background: none;
}

.ant-table-cell.ant-table-column-sort.ant-table-column-has-sorters {
	background-color: var(--dg-table-sort-bg);
}

.ant-table-thead th.ant-table-column-has-sorters:hover {
	background-color: var(--dg-table-sort-bg-hover);
}

.ant-table-thead > tr > th {
	border-bottom: 0;
}

.ant-table-column-sorters {
	display: flex;
	margin: 0;
	justify-content: flex-start;
	gap: 6px;
}

.ant-table-column-title {
	flex: initial;
}

.ant-table-wrapper-rtl .ant-table-column-sorter,
.ant-table-column-sorter {
	position: relative;
}

@media screen and (max-width: 1200px) {
	.ant-table-column-sorter-up,
	.ant-table-column-sorter-down {
		font-size: 9px;
	}
	.ant-table-wrapper-rtl .ant-table-column-sorter,
	.ant-table-column-sorter {
		margin: 0 3px;
	}
}

/* pagination */

.anticon {
	vertical-align: text-top;
}

.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis {
	color: var(--dg-primary-color);
}

.ant-pagination-rtl
	.ant-pagination-options
	.ant-pagination-options-size-changer.ant-select {
	margin-left: 0;
}

/* pop over */

.ant-popover-buttons .ant-btn.ant-btn-primary.ant-btn-sm {
	color: var(--dg-opposite-primary-color);
}

/* input number */

.ant-input-number-handler-wrap {
	display: none;
}

.ant-input-number {
	width: 100%;
}

.ant-input-number-input {
	padding: 0;
}

.suffix-icon {
	position: absolute;
	top: 10px;
	left: 10px;
}

.suffix-icon-ltr {
	position: absolute;
	top: 10px;
	right: 10px;
}

.ant-input-number-input,
.ant-input-number-input-wrap {
	height: 100%;
}

/* modal */

.ant-modal-body {
	padding: 0;
}

.wallet-invoice .ant-modal-header,
.wallet-invoice .ant-modal-body {
	background-color: var(--dg-white-color);
}

.wallet-invoice .ant-modal-header,
.wallet-invoice .ant-modal-close {
	display: none;
}

.wallet-invoice .ant-modal-body > div {
	padding: 0;
}

/*  form */

.ant-form-vertical .ant-form-item-label,
.ant-col-24.ant-form-item-label,
.ant-col-xl-24.ant-form-item-label {
	padding: 0 0 4px;
}

/* tab */

.ant-tabs-dropdown-menu-item {
	background-color: var(--dg-card-bg-1);
}

.ant-tabs-dropdown-menu-item:hover {
	background-color: var(--dg-card-bg-2);
}

.user-detail.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,
.user-detail.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap {
	background-color: var(--dg-card-bg-1);
	border-radius: 16px;
	padding-top: 23px;
}

.user-detail.ant-tabs
	> .ant-tabs-nav
	.ant-tabs-nav-wrap:not(.user-activity .ant-tabs-nav),
.user-detail.ant-tabs
	> div
	> .ant-tabs-nav
	.ant-tabs-nav-wrap:not(.user-activity .ant-tabs-nav) {
	background-color: var(--dg-card-bg-1);
	border-radius: 16px;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	padding-top: 23px;
}

.user-detail .ant-tabs-nav:not(.user-activity .ant-tabs-nav) {
	display: none;
}

.ant-tabs-left
	> .ant-tabs-content-holder
	> .ant-tabs-content
	> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav),
.ant-tabs-left
	> div
	> .ant-tabs-content-holder
	> .ant-tabs-content
	> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav) {
	padding: 0;
}

@media (min-width: 769px) {
	.user-detail .ant-tabs-nav:not(.user-activity .ant-tabs-nav) {
		display: flex;
	}
	[dir='ltr']
		.ant-tabs-left
		> .ant-tabs-content-holder
		> .ant-tabs-content
		> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav),
	[dir='ltr']
		.ant-tabs-left
		> div
		> .ant-tabs-content-holder
		> .ant-tabs-content
		> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav) {
		padding-left: 24px;
	}

	[dir='rtl'] .rtl\\:rtl-user-detail {
		flex-direction: row-reverse;
	}

	[dir='rtl']
		.ant-tabs-left
		> .ant-tabs-content-holder
		> .ant-tabs-content
		> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav),
	[dir='rtl']
		.ant-tabs-left
		> div
		> .ant-tabs-content-holder
		> .ant-tabs-content
		> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav) {
		padding-right: 24px;
	}
}

.ant-tabs-left > .ant-tabs-content-holder,
.ant-tabs-left > div > .ant-tabs-content-holder {
	border-left: 0;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {
	position: static;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::before {
	height: 0;
}

.ant-tabs-extra-content {
	width: 100%;
}

/* user detail tab nav */

.user-detail .ant-tabs-nav:not(.user-activity .ant-tabs-nav) {
	position: sticky;
	top: 105px;
	height: calc(100vh - 130px);
	min-width: 160px;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar {
	left: 0;
}

/* text area */

textarea.ant-input {
	padding-top: 14px;
}

/* switch */

.ant-switch-loading-icon.anticon {
	color: var(--dg-primary-color);
}

/* menu */

.ant-dropdown {
	z-index: 999999999;
}

.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover,
.ant-dropdown-menu-item.ant-dropdown-menu-item-active,
.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active,
.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active {
	background-color: transparent;
}

.ant-dropdown-menu-item,
.ant-dropdown-menu-submenu-title,
.ant-dropdown-menu {
	padding: 0;
}

.ant-dropdown-menu {
	background-color: transparent;
}

.ant-dropdown-menu-item,
.ant-dropdown-menu-submenu-title {
	cursor: default;
}

/* image */

.ant-image-preview-img-wrapper {
	position: initial;
	display: flex;
	min-height: 100%;
	align-items: center;
	justify-content: center;
}

.ant-image-mask-info {
	height: 20px;
}

.ant-image {
	width: 100%;
	height: 100%;
}

.ant-image-mask-info .anticon {
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.ant-image-mask-info {
	position: relative;
	font-size: 20px;
}

/* breadcrumb */

.ant-breadcrumb a,
.ant-breadcrumb-separator {
	color: var(--dg-primary-color);
	transition: 0.3s all;
}

.ant-breadcrumb a:hover {
	color: var(--dg-disabled-color-light);
}

/* steps */

.ant-steps-item-process
	> .ant-steps-item-container
	> .ant-steps-item-content
	> .ant-steps-item-title {
	color: var(--dg-primary-color);
}

.ant-steps-item-wait
	> .ant-steps-item-container
	> .ant-steps-item-content
	> .ant-steps-item-title {
	color: var(--dg-disabled-color-light);
}

.ant-steps-item-process
	> .ant-steps-item-container
	> .ant-steps-item-icon
	.ant-steps-icon {
	color: var(--dg-primary-color-fixed);
}

/* alert */

.ant-alert-message {
	color: var(--dg-primary-color);
}

/* tooltip */

.ant-tooltip {
	z-index: 999999999999999999999999999;
}

.ant-tooltip-inner {
	background-color: rgba(0, 0, 0, 0.897);
}

/* badge */

.ant-badge-count {
	color: var(--dg-white-color);
}

/* ant switch */
.ant-switch {
	background-color: var(--dg-switch-bg);
}

.ant-switch-checked {
	background-color: var(--dg-orange-color);
}
`, "",{"version":3,"sources":["webpack://./src/core/theme/antdConfigure.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;CACC,qBAAqB;AACtB;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,aAAa;AACd;;AAEA;;CAEC,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,MAAM;AACP;;AAEA;CACC,YAAY;AACb;;AAEA;;;CAGC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,qDAAqD;CACrD,4BAA4B;AAC7B;;AAEA;;;;;CAKC,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA,WAAW;;AAEX;CACC,oCAAoC;AACrC;;AAEA;CACC,6BAA6B;CAC7B,oCAAoC;CACpC,6BAA6B;AAC9B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;;;;;CAKC,gDAAgD;CAChD,yBAAyB;AAC1B;;AAEA;CACC,8CAA8C;CAC9C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,8BAA8B;CAC9B,qCAAqC;AACtC;;AAEA;CACC,6CAA6C;CAC7C,oCAAoC;AACrC;;AAEA;;CAEC,uCAAuC;CACvC,4BAA4B;CAC5B,mCAAmC;AACpC;;AAEA;CACC,2CAA2C;CAC3C,4BAA4B;AAC7B;;AAEA;CACC,2CAA2C;CAC3C,4BAA4B;AAC7B;;AAEA,UAAU;;AAEV;CACC,yBAAyB;AAC1B;;AAEA;CACC,0CAA0C;CAC1C,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;;;;GAMG;;AAEH;CACC,wCAAwC;AACzC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,2BAA2B;CAC3B,QAAQ;AACT;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC;;EAEC,cAAc;CACf;CACA;;EAEC,aAAa;CACd;AACD;;AAEA,eAAe;;AAEf;CACC,wBAAwB;AACzB;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;;;CAGC,cAAc;AACf;;AAEA,aAAa;;AAEb;CACC,uCAAuC;AACxC;;AAEA,iBAAiB;;AAEjB;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;;CAEC,YAAY;AACb;;AAEA,UAAU;;AAEV;CACC,UAAU;AACX;;AAEA;;CAEC,uCAAuC;AACxC;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA,UAAU;;AAEV;;;CAGC,gBAAgB;AACjB;;AAEA,QAAQ;;AAER;CACC,qCAAqC;AACtC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;;CAEC,qCAAqC;CACrC,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;;;;;;;CAOC,qCAAqC;CACrC,mBAAmB;CACnB,yBAAyB;CACzB,0BAA0B;CAC1B,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;;;;;;;;;CASC,UAAU;AACX;;AAEA;CACC;EACC,aAAa;CACd;CACA;;;;;;;;;;;EAWC,kBAAkB;CACnB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;;;;;;;;;;;EAWC,mBAAmB;CACpB;AACD;;AAEA;;CAEC,cAAc;AACf;;AAEA;;;;CAIC,gBAAgB;AACjB;;AAEA;;CAEC,SAAS;AACV;;AAEA;CACC,WAAW;AACZ;;AAEA,wBAAwB;;AAExB;CACC,gBAAgB;CAChB,UAAU;CACV,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,OAAO;AACR;;AAEA,cAAc;;AAEd;CACC,iBAAiB;AAClB;;AAEA,WAAW;;AAEX;CACC,8BAA8B;AAC/B;;AAEA,SAAS;;AAET;CACC,kBAAkB;AACnB;;AAEA;;;;;;CAMC,6BAA6B;AAC9B;;AAEA;;;CAGC,UAAU;AACX;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;CAEC,eAAe;AAChB;;AAEA,UAAU;;AAEV;CACC,iBAAiB;CACjB,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA,eAAe;;AAEf;;CAEC,8BAA8B;CAC9B,oBAAoB;AACrB;;AAEA;CACC,qCAAqC;AACtC;;AAEA,UAAU;;AAEV;;;;CAIC,8BAA8B;AAC/B;;AAEA;;;;CAIC,qCAAqC;AACtC;;AAEA;;;;CAIC,oCAAoC;AACrC;;AAEA,UAAU;;AAEV;CACC,8BAA8B;AAC/B;;AAEA,YAAY;;AAEZ;CACC,oCAAoC;AACrC;;AAEA;CACC,sCAAsC;AACvC;;AAEA,UAAU;;AAEV;CACC,4BAA4B;AAC7B;;AAEA,eAAe;AACf;CACC,qCAAqC;AACtC;;AAEA;CACC,wCAAwC;AACzC","sourcesContent":["/* select */\n\n.ant-form-item-control-input-content > .ant-select:hover > .ant-select-selector {\n\tborder-right-width: 0;\n}\n\n.float-group.password-input\n\t.ant-select:not(.ant-select-disabled):hover\n\t.ant-select-selector {\n\tborder-right-width: 0;\n}\n\n.ant-select-dropdown {\n\tz-index: 99999999999999999999999999;\n}\n\n.ant-select-multiple .ant-select-selection-item {\n\tbackground-color: var(--dg-card-bg-1);\n}\n\n.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tcolor: inherit;\n}\n\n.ant-select:not(.ant-select-customize-input) .ant-select-selector,\ntextarea {\n\tborder-radius: 6px;\n}\n\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n\tline-height: 42px;\n}\n\n.ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tmin-height: 50px;\n\tpadding: 10px;\n}\n\n.ant-select-rtl.ant-select-single .ant-select-selector .ant-select-selection-item,\n.ant-select-single.ant-select-show-arrow .ant-select-selection-item {\n\ttop: 2px;\n\tpadding-right: 3px;\n}\n\n.ant-pagination-options-size-changer.ant-select-open .ant-select-arrow {\n\ttransform: rotate(0deg);\n\ttransition: 300ms all;\n}\n\n.ant-pagination-options-size-changer .ant-select-arrow {\n\ttransform: rotate(180deg);\n\ttransition: 300ms all;\n}\n\n.label-left .ant-form-item-row .ant-form-item-label {\n\ttext-align: left;\n}\n\n.label-right .ant-form-item-row .ant-form-item-label {\n\ttext-align: right;\n}\n\n.ant-pagination-options-size-changer .ant-select-selection-item {\n\ttop: 0;\n}\n\n.ant-pagination-options-size-changer {\n\twidth: 110px;\n}\n\n.ant-select-show-search.ant-select:not(.ant-select-customize-input)\n\t.ant-select-selector\n\tinput {\n\theight: 100%;\n}\n\n.ant-select-selection-placeholder {\n\tflex: initial;\n}\n\n.wallet-deposit .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tborder: none;\n\tborder-bottom: 1px solid var(--dg-input-border-color);\n\tborder-radius: 16px 16px 0 0;\n}\n\n.wallet-deposit\n\t.ant-select-focused:not(.ant-select-disabled).ant-select:not(\n\t\t.ant-select-customize-input\n\t)\n\t.ant-select-selector {\n\tbox-shadow: none;\n}\n\n.ant-select-disabled .ant-select-selection-placeholder {\n\tcolor: var(--dg-disabled-color-light);\n}\n\n.ant-input-suffix {\n\tposition: relative;\n\tbottom: 4px;\n}\n\n/* button */\n\n.ant-btn-ghost {\n\tborder-color: var(--dg-orange-color);\n}\n\n.ant-btn-background-ghost.ant-btn-primary:focus {\n\tbackground-color: transparent;\n\tborder-color: var(--dg-orange-color);\n\tcolor: var(--dg-orange-color);\n}\n\n.ant-btn-background-ghost.ant-btn-primary:hover {\n\tcolor: var(--dg-primary-color-fixed);\n}\n\n.ant-btn-primary:hover,\n.ant-btn[disabled],\n.ant-btn[disabled]:hover,\n.ant-btn[disabled]:focus,\n.ant-btn[disabled]:active {\n\tbackground-color: var(--dg-orange-color-hover-2);\n\tborder-color: transparent;\n}\n\n.ant-btn-primary:hover {\n\tbackground-color: var(--dg-orange-color-hover);\n\tborder-color: transparent;\n}\n\n.ant-btn-primary:focus {\n\tbackground-color: var(--dg-orange-color);\n\tcolor: var(--dg-opposite-primary-color);\n\tborder-color: transparent;\n}\n\n.ant-btn.ant-btn-default:focus {\n\tbackground-color: var(--dg-popOver-bg);\n\tcolor: var(--dg-primary-color);\n\tborder-color: var(--dg-primary-color);\n}\n\n.ant-btn.ant-btn-default:hover {\n\tbackground-color: var(--dg-button-default-bg);\n\tcolor: var(--dg-button-default-text);\n}\n\n.btn-danger,\n.btn-danger:checked {\n\tbackground-color: var(--dg-red-color-2);\n\tcolor: var(--dg-white-color);\n\tborder-color: var(--dg-red-color-2);\n}\n\n.btn-danger:hover {\n\tbackground-color: var(--dg-red-color-hover);\n\tcolor: var(--dg-white-color);\n}\n\n.btn-danger:focus {\n\tbackground-color: var(--dg-red-color-hover);\n\tcolor: var(--dg-white-color);\n}\n\n/* table */\n\n.ant-table-tbody > tr > td {\n\tborder-color: transparent;\n}\n\n.ant-table-tbody > tr:not(:last-child) > td {\n\tborder-color: var(--dg-table-border-color);\n\t/* padding: 18px 8px; */\n}\n\n.ant-table-tbody > tr > td {\n\tbackground-color: var(--dg-table-bg);\n}\n\n.ant-table-thead,\n.ant-table-tbody > tr > td {\n\theight: 60px;\n}\n\n/* .ant-table-tbody>tr.ant-table-row:nth-child(even)>td {\n    background-color: var(--dg-table-row-even-bg);\n}\n\n.ant-table-tbody>tr.ant-table-row:nth-child(odd)>td {\n    background-color: var(--dg-table-bg);\n} */\n\n.ant-table-tbody > tr.ant-table-row:hover > td {\n\tbackground-color: var(--table-row-hover);\n}\n\n.ant-table-tbody > tr.ant-table-placeholder:hover > td {\n\tbackground: none;\n}\n\n.ant-table-cell.ant-table-column-sort.ant-table-column-has-sorters {\n\tbackground-color: var(--dg-table-sort-bg);\n}\n\n.ant-table-thead th.ant-table-column-has-sorters:hover {\n\tbackground-color: var(--dg-table-sort-bg-hover);\n}\n\n.ant-table-thead > tr > th {\n\tborder-bottom: 0;\n}\n\n.ant-table-column-sorters {\n\tdisplay: flex;\n\tmargin: 0;\n\tjustify-content: flex-start;\n\tgap: 6px;\n}\n\n.ant-table-column-title {\n\tflex: initial;\n}\n\n.ant-table-wrapper-rtl .ant-table-column-sorter,\n.ant-table-column-sorter {\n\tposition: relative;\n}\n\n@media screen and (max-width: 1200px) {\n\t.ant-table-column-sorter-up,\n\t.ant-table-column-sorter-down {\n\t\tfont-size: 9px;\n\t}\n\t.ant-table-wrapper-rtl .ant-table-column-sorter,\n\t.ant-table-column-sorter {\n\t\tmargin: 0 3px;\n\t}\n}\n\n/* pagination */\n\n.anticon {\n\tvertical-align: text-top;\n}\n\n.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis,\n.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis {\n\tcolor: var(--dg-primary-color);\n}\n\n.ant-pagination-rtl\n\t.ant-pagination-options\n\t.ant-pagination-options-size-changer.ant-select {\n\tmargin-left: 0;\n}\n\n/* pop over */\n\n.ant-popover-buttons .ant-btn.ant-btn-primary.ant-btn-sm {\n\tcolor: var(--dg-opposite-primary-color);\n}\n\n/* input number */\n\n.ant-input-number-handler-wrap {\n\tdisplay: none;\n}\n\n.ant-input-number {\n\twidth: 100%;\n}\n\n.ant-input-number-input {\n\tpadding: 0;\n}\n\n.suffix-icon {\n\tposition: absolute;\n\ttop: 10px;\n\tleft: 10px;\n}\n\n.suffix-icon-ltr {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n}\n\n.ant-input-number-input,\n.ant-input-number-input-wrap {\n\theight: 100%;\n}\n\n/* modal */\n\n.ant-modal-body {\n\tpadding: 0;\n}\n\n.wallet-invoice .ant-modal-header,\n.wallet-invoice .ant-modal-body {\n\tbackground-color: var(--dg-white-color);\n}\n\n.wallet-invoice .ant-modal-header,\n.wallet-invoice .ant-modal-close {\n\tdisplay: none;\n}\n\n.wallet-invoice .ant-modal-body > div {\n\tpadding: 0;\n}\n\n/*  form */\n\n.ant-form-vertical .ant-form-item-label,\n.ant-col-24.ant-form-item-label,\n.ant-col-xl-24.ant-form-item-label {\n\tpadding: 0 0 4px;\n}\n\n/* tab */\n\n.ant-tabs-dropdown-menu-item {\n\tbackground-color: var(--dg-card-bg-1);\n}\n\n.ant-tabs-dropdown-menu-item:hover {\n\tbackground-color: var(--dg-card-bg-2);\n}\n\n.user-detail.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap,\n.user-detail.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap {\n\tbackground-color: var(--dg-card-bg-1);\n\tborder-radius: 16px;\n\tpadding-top: 23px;\n}\n\n.user-detail.ant-tabs\n\t> .ant-tabs-nav\n\t.ant-tabs-nav-wrap:not(.user-activity .ant-tabs-nav),\n.user-detail.ant-tabs\n\t> div\n\t> .ant-tabs-nav\n\t.ant-tabs-nav-wrap:not(.user-activity .ant-tabs-nav) {\n\tbackground-color: var(--dg-card-bg-1);\n\tborder-radius: 16px;\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n\tpadding-top: 23px;\n}\n\n.user-detail .ant-tabs-nav:not(.user-activity .ant-tabs-nav) {\n\tdisplay: none;\n}\n\n.ant-tabs-left\n\t> .ant-tabs-content-holder\n\t> .ant-tabs-content\n\t> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav),\n.ant-tabs-left\n\t> div\n\t> .ant-tabs-content-holder\n\t> .ant-tabs-content\n\t> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav) {\n\tpadding: 0;\n}\n\n@media (min-width: 769px) {\n\t.user-detail .ant-tabs-nav:not(.user-activity .ant-tabs-nav) {\n\t\tdisplay: flex;\n\t}\n\t[dir='ltr']\n\t\t.ant-tabs-left\n\t\t> .ant-tabs-content-holder\n\t\t> .ant-tabs-content\n\t\t> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav),\n\t[dir='ltr']\n\t\t.ant-tabs-left\n\t\t> div\n\t\t> .ant-tabs-content-holder\n\t\t> .ant-tabs-content\n\t\t> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav) {\n\t\tpadding-left: 24px;\n\t}\n\n\t[dir='rtl'] .rtl\\:rtl-user-detail {\n\t\tflex-direction: row-reverse;\n\t}\n\n\t[dir='rtl']\n\t\t.ant-tabs-left\n\t\t> .ant-tabs-content-holder\n\t\t> .ant-tabs-content\n\t\t> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav),\n\t[dir='rtl']\n\t\t.ant-tabs-left\n\t\t> div\n\t\t> .ant-tabs-content-holder\n\t\t> .ant-tabs-content\n\t\t> .ant-tabs-tabpane:not(.user-activity .ant-tabs-nav) {\n\t\tpadding-right: 24px;\n\t}\n}\n\n.ant-tabs-left > .ant-tabs-content-holder,\n.ant-tabs-left > div > .ant-tabs-content-holder {\n\tborder-left: 0;\n}\n\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::before,\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-wrap::after {\n\tposition: static;\n}\n\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap::before {\n\theight: 0;\n}\n\n.ant-tabs-extra-content {\n\twidth: 100%;\n}\n\n/* user detail tab nav */\n\n.user-detail .ant-tabs-nav:not(.user-activity .ant-tabs-nav) {\n\tposition: sticky;\n\ttop: 105px;\n\theight: calc(100vh - 130px);\n\tmin-width: 160px;\n}\n\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-ink-bar {\n\tleft: 0;\n}\n\n/* text area */\n\ntextarea.ant-input {\n\tpadding-top: 14px;\n}\n\n/* switch */\n\n.ant-switch-loading-icon.anticon {\n\tcolor: var(--dg-primary-color);\n}\n\n/* menu */\n\n.ant-dropdown {\n\tz-index: 999999999;\n}\n\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-item.ant-dropdown-menu-item-active,\n.ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active,\n.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active {\n\tbackground-color: transparent;\n}\n\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu {\n\tpadding: 0;\n}\n\n.ant-dropdown-menu {\n\tbackground-color: transparent;\n}\n\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n\tcursor: default;\n}\n\n/* image */\n\n.ant-image-preview-img-wrapper {\n\tposition: initial;\n\tdisplay: flex;\n\tmin-height: 100%;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.ant-image-mask-info {\n\theight: 20px;\n}\n\n.ant-image {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ant-image-mask-info .anticon {\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n}\n\n.ant-image-mask-info {\n\tposition: relative;\n\tfont-size: 20px;\n}\n\n/* breadcrumb */\n\n.ant-breadcrumb a,\n.ant-breadcrumb-separator {\n\tcolor: var(--dg-primary-color);\n\ttransition: 0.3s all;\n}\n\n.ant-breadcrumb a:hover {\n\tcolor: var(--dg-disabled-color-light);\n}\n\n/* steps */\n\n.ant-steps-item-process\n\t> .ant-steps-item-container\n\t> .ant-steps-item-content\n\t> .ant-steps-item-title {\n\tcolor: var(--dg-primary-color);\n}\n\n.ant-steps-item-wait\n\t> .ant-steps-item-container\n\t> .ant-steps-item-content\n\t> .ant-steps-item-title {\n\tcolor: var(--dg-disabled-color-light);\n}\n\n.ant-steps-item-process\n\t> .ant-steps-item-container\n\t> .ant-steps-item-icon\n\t.ant-steps-icon {\n\tcolor: var(--dg-primary-color-fixed);\n}\n\n/* alert */\n\n.ant-alert-message {\n\tcolor: var(--dg-primary-color);\n}\n\n/* tooltip */\n\n.ant-tooltip {\n\tz-index: 999999999999999999999999999;\n}\n\n.ant-tooltip-inner {\n\tbackground-color: rgba(0, 0, 0, 0.897);\n}\n\n/* badge */\n\n.ant-badge-count {\n\tcolor: var(--dg-white-color);\n}\n\n/* ant switch */\n.ant-switch {\n\tbackground-color: var(--dg-switch-bg);\n}\n\n.ant-switch-checked {\n\tbackground-color: var(--dg-orange-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
